import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=5c785603&scoped=true&"
import script from "./Footerbar.vue?vue&type=script&lang=js&"
export * from "./Footerbar.vue?vue&type=script&lang=js&"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=5c785603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c785603",
  null
  
)

export default component.exports